<template>
  <div class="s-layout" :style="colorObject">
    <Loading v-if="isLoading" loading-message="載入中..." :background-color="'#ffffff'" />
    <div class="scanner-view" v-if="isDisplayingQrcodeScanner">
      <div class="scanner-view__body">
        <div class="scanner-view__title mb-3">請將 QR code 對準框線</div>
        <QRCodeScanner @onScan="handleQrCodeIsScanned" :qrbox="qrbox" ref="qrScanner" class="scanner-view__scanner" />
        <button class="scanner-view__close s-btn s-btn-outline-primary s-btn-xs mt-3" type="button"
          @click="handleCloseScannerButtonIsClicked">
          取消
        </button>
      </div>
    </div>
    <div class="s-container">
      <div class="content" :style="colors">
        <div class="custom-elanco-header">
          <span class="custom-elanco-header__text">Hi {{ deepGet(user, 'name') }}</span>
          <a :href="deepGet(event, 'config.header_logo_url', '#')">
            <img
              v-if="deepGet(event, 'config.images.header_logo')"
              :src="deepGet(event, 'config.images.header_logo')"
              class="custom-elanco-header__image ml-3"
            >
          </a>
        </div>

        <!-- page: redeem start -->
        <div v-if="page === 'redeem'">
          <img v-if="deepGet(event, 'config.images.redeem_confirm_kv')" :src="deepGet(event, 'config.images.redeem_confirm_kv')" alt="Elanco" class="img-fluid">

          <div class="py-3 px-4">
            <!-- Redeem Notes Top -->
            <div class="redeem-notes redeem-notes--top mb-3" v-if="deepGet(event, 'config.redeem_notes_top')" v-html="deepGet(event, 'config.redeem_notes_top')">
            </div>

            <!-- Branch Select Dropdown -->
            <div class="card__info">
              <ShopSelection
                v-model="branchId"
                ref="shopSelection"
                :disabled="isLoading || !branchProvider || isRedeemSuccess || hasError || isOverMaxRedeemCount"
                :branch-provider="branchProvider || ''"
                :show-branch-code="false"
                :placeholder="'請選擇獸醫院'"
                @selected="handleBranchIsSelected"
              />
            </div>

            <!-- Branch Code Input -->
            <div class="card__info">
              <input
                type="text"
                class="form-control-input"
                :placeholder="deepGet(event, 'config.branch_placeholder', '請輸入分店代碼')"
                v-model="branchCode"
                :disabled="isRedeemSuccess || hasError || isOverMaxRedeemCount"
              />
            </div>

            <!-- Redeem Notes Bottom -->
            <div class="redeem-notes redeem-notes--bottom mt-3" v-if="deepGet(event, 'config.redeem_notes_bottom')" v-html="deepGet(event, 'config.redeem_notes_bottom')">
            </div>

            <!-- Buttons Start -->
            <div class="btn-container btn-container--redeem">
              <button
                class="s-btn s-btn-primary s-btn-xs"
                type="button"
                :disabled="isLoading || isRedeemSuccess || isOverMaxRedeemCount || (!branchId && !branchCode)"
                @click="redeem"
              >
                確定送出
              </button>

              <button class="s-btn s-btn-outline-primary s-btn-xs mt-2" type="button" :disabled="isLoading" @click="goToPointsProgress">
                查看集點進度
              </button>

              <button class="s-btn s-btn-outline-primary s-btn-xs mt-2" type="button" :disabled="isLoading" @click="goToCouponList">
                查看回饋詳情
              </button>

              <button class="s-btn s-btn-outline-primary s-btn-xs mt-2" type="button" :disabled="isLoading" @click="goToElancoIntro">
                查看活動辦法
              </button>
            </div>
            <!-- Buttons End -->
          </div>
        </div>
        <!-- page: redeem End -->

        <!-- page: redeem success start -->
        <div v-if="page === 'redeem_success'" class="content__success">
          <img v-if="deepGet(event, 'config.images.redeem_success')" :src="deepGet(event, 'config.images.redeem_success')" alt="Elanco" class="img-fluid">

          <div class="py-3 px-4">
            <div class="content__success__messages">
              <div v-if="redeemSuccessTitleMessage" class="text-center py-2 content__success__title" v-html="redeemSuccessTitleMessage"></div>
            </div>

            <div v-if="deepGet(event, 'config.general_redeem_success_message', '')" class="text-center py-2 mt-4 content__success__title content__success__general-message" v-html="deepGet(event, 'config.general_redeem_success_message', '')">
            </div>

            <div class="content__sub_success__messages">
              <div v-if="redeemSuccessSubTitleMessage" class="text-center py-2 content__success__sub__title" v-html="redeemSuccessSubTitleMessage"></div>
            </div>
          </div>
        </div>
        <!-- page: redeem success End -->

        <div class="py-3 px-4" v-if="page === 'redeem_success'">
        <button class="s-btn s-btn-outline-primary s-btn-xs mb-2" type="button" :disabled="isLoading" @click="goToPointsProgress">
            查看集點進度
        </button>

        <button class="s-btn s-btn-outline-primary s-btn-xs" type="button" :disabled="isLoading" @click="goToCouponList">
          查看回饋詳情
        </button>
        </div>

        <!-- page: card start-->
        <div v-if="page === 'card'" class="content__card d-flex flex-column content__card__bg">
          <!-- Branch Select -->


          <div class="content__card__level py-3 d-flex justify-content-center">
            <img :src="redeemCycleImage" class="mx-2 img-fluid" />
          </div>

          <div class="content__card__remaining text-center" v-html="redeemCycleMessage"></div>


          <!-- Buttons Start -->
          <div class="content__card__buttons py-3">
            <button class="btn btn-link my-1 mx-2" @click="handleOpenScannerButtonIsClicked">
              <img src="./images/2026/card-btn-1.png" class="img-fluid" />
            </button>

            <button v-if="shouldShowMgmButton" class="btn btn-link my-1 mx-2" @click="handleShareButtonIsClicked">
              <img src="./images/2026/card-btn-2.png" class="img-fluid" />
            </button>

            <button class="btn btn-link my-1 mx-2" @click="goToCouponList">
              <img src="./images/2026/card-btn-3.png" class="img-fluid" />
            </button>
          </div>
          <!-- Buttons End -->

        </div>
        <!-- page: card end-->

        <!-- page: empty message start-->
        <div v-if="page === 'empty_message'">
          <div class="card">
            <p class="alert-message">
              網址錯誤，沒有活動代碼或序號
            </p>
          </div>
          <div class="btn-container">
            <button class="s-btn s-btn-bg-primary s-btn-xs" type="button" @click="goBack">
              返回上一頁
            </button>
          </div>
        </div>
        <!-- page: empty message end-->
      </div>
    </div>
  </div>
</template>

<script>
// Packages
import { mapGetters } from "vuex";
import { isAfter } from "date-fns";
import deepGet from "lodash/get";
import liff from "@line/liff";
// Waltily Utils
import { themeColorFn } from "@/mixins/liff/themeColor";
import dateOptionMixin from "@/mixins/liff/dateOption";
import https from "@/apis/liff/v2/https";
// Components
import Loading from "@/components/Page/Liff/Shared/Loading";
import ShopSelection from "@/components/Page/Liff/Branch/ShopSelection";
import QRCodeScanner from "@/components/QRCodeScanner.vue";
// Api
import redeemApi from "@/apis/liff/v2/redeem";



export default {
  mixins: [
    themeColorFn({ themeConfigPage: 'redeem' }),
    dateOptionMixin,
  ],
  components: {
    Loading,
    ShopSelection,
    QRCodeScanner,
  },
  mounted() {
    if (this.$route.query.event_code) {
      this.eventCode = this.$route.query.event_code;
    } else {
      this.$swal({
        text: '網址錯誤，沒有活動代碼',
        confirmButtonText: '確定',
      })
      this.page = 'empty_message';
      return;
    }

    if (this.$route.params.code) {
      this.code = this.$route.params.code;
    } else {
      this.page = 'card';
    }

     this.fetchEvent();
  },
  data() {
    return {
      isLoading: false,
      qrbox: {
        width: 200,
        height: 200,
      },
      isDisplayingQrcodeScanner: false,
      eventCode: null,
      event: {
        config: {},
      },
      code: null,
      page: 'redeem', // redeem, redeem_success, empty_message
      branchId: null,
      branchCode: '',
      branchProvider: '',
      isRedeemSuccess: false,
      hasError: false,
      successMessageFlags: {},
      redeemed_count: null,
      error_message: [],
      sharePickerLink: '',
    };
  },
  computed: {
    ...mapGetters({
      meta: "liffGeneral/meta",
      themeConfig: "liffGeneral/themeConfig",
      liffId: "liffGeneral/liffId",
    }),
    ...mapGetters("liffAuth", ["user"]),
    isEventTime() {
      if (this.event) {
        const now = new Date();
        return isAfter(now, new Date(this.event.start_at)) && isAfter(new Date(this.event.end_at), now);
      }
      return false;
    },

    colors() {
      return {
        "--header_bg_color": this.event.config.header_bg_color,
        "--header_text_color": this.event.config.header_text_color,
        "--submit_bg_color": this.event.config.submit_bg_color,
        "--submit_text_color": this.event.config.submit_text_color,
      }
    },
    maxRedeemCount() {
      return deepGet(this.event, 'config.max_redeem_count', null);
    },
    redeemCycleImage() {

      const imageIndex = this.redeemed_count <= 12 ? this.redeemed_count : ((this.redeemed_count - 9) % 4) + 9;

      return deepGet(this.event, 'config.redeem_cycle_images', []).find(item => item.count === imageIndex)?.image_url;
    },
    redeemCycleMessage() {

      if (this.remainingCount < 4 || this.redeemed_count == 0) {
          const message = deepGet(this.event, 'config.redeem_cycle_message', []).find(item => item.key === 'general')?.message;
          return message?.replace('{$N}', this.remainingCount);
      } else {
        return  deepGet(this.event, 'config.redeem_cycle_message', []).find(item => item.key === 'cycle')?.message;
      }


    },
    remainingCount() {
      return 4-this.redeemed_count%4;
    },
    isOverMaxRedeemCount() {
      return this.maxRedeemCount !== null && this.redeemed_count >= this.maxRedeemCount;
    },
    shouldShowMgmButton() {
      return Number(this.redeemed_count) > 0;
    },
    redeemSuccessTitleMessage() {
      return this.joinSuccessMessages([
        deepGet(this.event, 'config.redeem_success_message', ''),
        this.shouldShow('redeem_success_message_bonus') ? deepGet(this.event, 'config.redeem_success_message_bonus', '') : '',
        this.shouldShow('mgm_redeem_success_message') ? deepGet(this.event, 'config.mgm.redeem_success_message', '') : '',
        this.shouldShow('old_friend_applied_success_message') ? deepGet(this.event, 'config.old_friend.applied_success_message', '') : '',
      ]);
    },
    redeemSuccessSubTitleMessage() {
      return this.joinSuccessMessages([
        deepGet(this.event, 'config.sub_redeem_success_message', ''),
        this.shouldShow('redeem_success_message_bonus') ? deepGet(this.event, 'config.sub_redeem_success_message_bonus', '') : '',
        this.shouldShow('mgm_redeem_success_message') ? deepGet(this.event, 'config.mgm.sub_redeem_success_message', '') : '',
        this.shouldShow('old_friend_applied_success_message') ? deepGet(this.event, 'config.old_friend.sub_applied_success_message', '') : '',
      ]);
    },
  },

  methods: {
    deepGet,
    joinSuccessMessages(messages = []) {
      return messages.filter(Boolean).join('<br>');
    },
    shouldShow(messageKey) {
      return Boolean(this.successMessageFlags[messageKey]);
    },
    getModuleConfig(key) {
      return this.$store.getters["liffModule/getConfig"]("liff_redeem", key);
    },
    async fetchEvent() {
      try {
        this.isLoading = true;

        const eventRes = await redeemApi.getRedeemEvent({
          event_code: this.eventCode,
        });

        this.event = eventRes.data.data.event;
        this.error_message = eventRes.data.data.event.config.error_message ?? [];

        const response = await https.get(`${this.$store.state.liffGeneral.orgCode}/liff/elanco/init2026`, {
          params: {
            event_code: this.eventCode,
            redeem_code: this.code,
          }
        });

        this.redeemed_count = response.data.data.redeemed_count;

        this.branchProvider = this.event.config.branch_provider ?? null;

        if (this.branchProvider && !this.branchProvider.startsWith('waltily.branch')) {
          this.branchProvider = `waltily.branch:${this.branchProvider}`;
        }

        if (this.page === 'redeem') {
          if (this.branchProvider) {
            this.$nextTick(() => {
              this.$refs.shopSelection.fetchBranchesOptions();
            });
          }

          if (this.isOverMaxRedeemCount) {
            const errorMessageConfig = this.findMappedError('REDEEM_LIMIT_REACHED');
            this.$swal({
              text: deepGet(errorMessageConfig, 'message', '已達兌換上限'),
              confirmButtonText: '確定',
            })
          }
        }
      } catch (error) {
        console.error(error);
        this.hasError = true;
        if (error.response?.status === 400) {
          const errorMessageConfig = this.findMappedError(error.response.data.message);
          this.$swal({
            text: deepGet(errorMessageConfig, 'message', '設定錯誤'),
            confirmButtonText: '確定',
          })
        } else {
          this.$swal({
            text: '活動資訊讀取失敗',
            confirmButtonText: '確定',
          })
        }
      } finally {
        this.isLoading = false;
      }
    },
    async redeem() {
      try {
        this.isLoading = true;

        if (!this.branchId && !this.branchCode) {
          this.$swal({
            text: '請選擇分店或輸入分店代碼',
            confirmButtonText: '確定',
          })
          return;
        }

        if (!this.eventCode || !this.code) {
          this.$swal({
            text: '網址錯誤，沒有活動代碼或序號',
            confirmButtonText: '確定',
          })
          return;
        }

        let response = await https.post(`${this.$store.state.liffGeneral.orgCode}/liff/elanco/redeem2026`, {
          redeem_code: this.code,
          event_code: this.eventCode,
          branch_id: this.branchId,
          branch_code: this.branchCode,
        });

        this.page = 'redeem_success';
        this.successMessageFlags = deepGet(response, 'data.message_flags', {});
      } catch (error) {
        console.error(error);
        this.hasError = true;
        if (error.response?.status === 400) {
          const errorMessageConfig = this.findMappedError(error.response.data.message);

          this.hasError = errorMessageConfig.code !== 'BRANCH_NOT_FOUND'

          this.$swal({
            text: deepGet(errorMessageConfig, 'message', '設定錯誤'),
            confirmButtonText: '確定',
          })
        } else {
          this.$swal({
            text: '發生錯誤，請稍後再試',
            confirmButtonText: '確定',
          })
        }
      } finally {
        this.isLoading = false;
      }
    },
    findMappedError(code) {
      const errorMessageConfig = this.error_message ?? [];
      return errorMessageConfig.find(item => item.code === code);
    },
    handleBranchIsSelected(value) {
      this.selectedBranch = value;
    },
    isValidUrl(string) {
      try {
        new URL(string);
        return true;
      } catch (_) {
        return false;
      }
    },
    async handleQrCodeIsScanned(decodedText) {
      if (!this.isValidUrl(decodedText)) {
        this.$swal({
          text: '掃描結果不是有效的 URL',
          confirmButtonText: '確定',
        })
        return;
      }
      window.location = decodedText;
    },
    handleOpenScannerButtonIsClicked() {
      this.isDisplayingQrcodeScanner = true;
    },
    handleCloseScannerButtonIsClicked() {
      this.$refs.qrScanner.stopScanner();
      this.isDisplayingQrcodeScanner = false;
    },
    goToCouponList() {
      if (!this.liffId) {
        this.$swal({
          text: 'LIFF 設定錯誤，請稍後再試',
          confirmButtonText: '確定',
        });
        return;
      }

      window.location.href = `https://liff.line.me/${this.liffId}/coupon`;
    },
    goToPointsProgress() {
      if (!this.liffId) {
        this.$swal({
          text: 'LIFF 設定錯誤，請稍後再試',
          confirmButtonText: '確定',
        });
        return;
      }

      window.location.href = `https://liff.line.me/${this.liffId}/proj/elanco/2026?event_code=elancotw2026`;
    },
    goToElancoIntro() {
      if (!this.liffId) {
        this.$swal({
          text: 'LIFF 設定錯誤，請稍後再試',
          confirmButtonText: '確定',
        });
        return;
      }

      window.location.href = `https://liff.line.me/${this.liffId}/page/elanco2026_intro`;
    },
    async fetchSharePickerMessage() {
      const response = await https.get(`${this.$store.state.liffGeneral.orgCode}/liff/share_picker_elanco`);
      return deepGet(response, 'data.data', {});
    },
    async handleShareButtonIsClicked() {
      try {
        if (!liff.isApiAvailable('shareTargetPicker')) {
          this.$swal({
            text: '此 LINE 帳號尚未開啟 Share Target Picker 功能',
            confirmButtonText: '確定',
          });
          return;
        }

        this.isLoading = true;
        const message = await this.fetchSharePickerMessage();

        await liff.shareTargetPicker([message], { isMultiple: true });
      } catch (error) {
        console.error(error);
        this.$swal({
          text: '發生錯誤，無法進行分享',
          confirmButtonText: '確定',
        });
      } finally {
        this.isLoading = false;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
  }
}
</script>

<style lang="scss" scoped>
.form-control-input {
  width: 100%;
  border: 1px solid #e5e5ea;
  border-radius: 5px;
  padding: 0.8rem;
  line-height: var(--s-text-xl-line-height);
  color: var(--s-gray-darker);

  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
}

.scanner-view {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: white;

  &__body {
    width: 500px;
    max-width: 100%;
    margin: 0 auto;
    padding: 0 32px;
  }

  &__title {
    font-size: 1.25rem;
    color: #555;
    text-align: center;
  }

  &__scanner {
    width: 100%;
    aspect-ratio: 1 / 1;
    background-color: #f5f5f5;
    border-radius: 8px;
    overflow: hidden;
  }
}

.custom-elanco-header {
  padding: 16px;
  background-color: var(--header_bg_color);
  color: var(--header_text_color);
  font-size: 1.25rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__image {
    height: 40px;
  }
}

.redeem-notes {
  font-size: 14px;
  color: #333;
  line-height: 1.6;

  &--top {
    margin-bottom: 16px;
  }

  &--bottom {
    margin-top: 16px;
  }
}

.btn-container {
  margin-top: 24px;
  margin-bottom: 24px;
  width: 100%;
}

.btn-container--redeem {
  margin-bottom: 2px;
}

.content__card__bg{
    padding-bottom: 0;
    min-height: calc(100vh - 72px);
    background: url('./images/2026/card-bg-1.jpg') no-repeat top center,
    url('./images/2026/card-bg-2.jpg') no-repeat bottom center,
    #f4edf4;
    background-size: 100%, 100%, 100%;
}

</style>

<style lang="scss">
@import "../../../../assets/css/liff/main.css";
@import "../../../../assets/css/liff/liff_init_theme_config.css";
@import '../../../../assets/scss/shared/components/_fields.scss';

.s-layout {
  color: var(--liff-primary_text_color);
  background-color: var(--liff-layout_bg_color);
  --s-gray: #979797 !important;
  --s-gray-light: #f0f0f0 !important;
}

.s-container {
  min-height: 100vh;
  position: relative;
  max-width: 768px;
  margin: auto;
}

.s-layout,
.s-layout *,
.s-layout *:before,
.s-layout *:after {
  --s-secondary: #de006f;
  --s-warning: #ed6c00;
  --s-danger: #fe0000;
  --s-gray-darker: #363636;
  --s-gray-dark: #2c2c2e;
  --s-gray: #979797 !important;
  --s-gray-light: #c0c4cc;
  --s-gray-lighter: #f2f2f7;
  --liff-button-color: #93bf65;
  --liff-primary_text_color: #93bf65;
  --s-primary: #93bf65;
}

.content {
  height: 100vh;
  overflow-y: auto;
  margin: 0;
  //padding-bottom: 24px;
  color: var(--liff-primary_text_color);

  &__success {
    &__messages {
      display: flex;
      flex-direction: column;
    }

    &__general-message {
      color: #008000;
    }

    &__title {
      font-size: 24px;
      font-weight: 600;
    }

    &__sub__title {
      color: black;
    }
  }

  &__card {

    padding-bottom: 0;

    background-color: var(--liff-primary_text_color);



    &__header {
      color: white;

      &__title {
        font-size: 20px;
        font-weight: 600;
      }

      &__level {
        font-size: 36px;
        font-weight: 600;
      }

      &__avatar {
        img {
          width: 110px;
          height: 110px;
        }
      }
    }

    &__remaining {
      font-size: 18px;
      font-weight: 600;
      color: #039544;
    }


  }
}

.card {
  margin-top: 24px;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 24px;
  margin-top: 12px;

  &__info {
    color: #636366;
    line-height: 24px;
    font-size: 16px;
    padding-top: 12px;
  }
}

.s-btn-primary {
  background-color: var(--liff-button-color) !important;
}

.s-btn-outline-primary {
  border-width: 3px !important;
}

.alert-message {
  text-align: center;
  color: var(--s-danger);
  font-size: 16px;
  padding: 12px;
  margin: 0;
}
</style>


